import React, { Fragment, useState, useEffect } from 'react';
import { Container, Alert, Table } from 'react-bootstrap';
import FuncionarioService from '../../../../services/funcionarios'
import Funcionario from './funcionario';
import '../../../../styles/diario.scss';
import FormBusca from './busca';
import { Navigate } from 'react-router-dom';


const FuncionariosScreen = () => {

    const [funcionarios, setFuncionarios] = useState([]);
    const [funcionariosOriginais, setFuncionariosOriginais] = useState([]);
    const [editar, setEditar] = useState(false);
    const [senha, setSenha] = useState(false);
    const [vazio, setVazio] = useState(false);
    const [verHolerites, setVerHolerites] = useState(false);
    const [funcionario, setFuncionario] = useState("");
    const [loading, setLoading] = useState(false);

    async function fetchFuncionarios() {
        setLoading(true);
        const response = await FuncionarioService.listar();
        if (response.data.length >= 1) {
            setFuncionarios(response.data);
            setFuncionariosOriginais(response.data);
            setLoading(false);
            setVazio(false);
        } else {
            setLoading(false);
            setFuncionarios([]);
            setFuncionariosOriginais([]);
            setVazio(true);
        }
    }

    const filtrarLocalmente = (nome, matricula, cargo) => {

        // Se todos vazios → voltar ao original
        if (!nome.trim() && !matricula.trim() && !cargo.trim()) {
            setFuncionarios(funcionariosOriginais);
            setVazio(false);
            return;
        }

        const filtrados = funcionariosOriginais.filter(f => {

            const matchNome = nome.trim()
                ? f.nome.toLowerCase().includes(nome.toLowerCase())
                : true;

            const matchMatricula = matricula.trim()
                ? String(f.matricula).includes(matricula)
                : true;

            const matchCargo = cargo.trim()
                ? f.cargo.toLowerCase().includes(cargo.toLowerCase())
                : true;

            return matchNome && matchMatricula && matchCargo;
        });

        if (filtrados.length >= 1) {
            setFuncionarios(filtrados);
            setVazio(false);
        } else {
            setFuncionarios([]);
            setVazio(true);
        }
    };

    const handleEditar = (id) => {
        setFuncionario(id);
        setEditar(true)
    }

    const handleSenha = (id) => {
        setFuncionario(id);
        setSenha(true)
    }

    const holerites = (id) => {
        setFuncionario(id);
        setVerHolerites(true);
    };

    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja excluir o funcionário?')) {
            try {
                await FuncionarioService.deletar(id)
                alert("Funcionário deletado com sucesso!")
                fetchFuncionarios();
            } catch (err) {
                alert("Algo deu errado ao deletar o funcionário!")
            }
        }
    }

    useEffect(() => {
        fetchFuncionarios();
    }, []);

    if (editar) {
        return (
            <Navigate to={`/rh/funcionarios/editar/${funcionario}`} />
        )
    } else if (senha) {
        return <Navigate to={`/rh/funcionarios/senha/${funcionario}`} />;
    } else if (verHolerites && funcionario) {
        return <Navigate to={`/rh/funcionarios/holerites/${funcionario}`} />;
    }
    else {
        return (
            <Fragment>
                <Container>
                    <Fragment>
                        <FormBusca
                            fetchFuncionarios={fetchFuncionarios}
                            filtrarLocalmente={filtrarLocalmente}
                        />
                    </Fragment>
                    {vazio ? <Fragment>
                        <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                    </Fragment> :
                        <Fragment>
                            <br />
                            <Table className="table table-bordered tabela-rh">
                                <thead>
                                    <tr>
                                        <th>Funcionário</th>
                                        <th>Matrícula</th>
                                        <th>Cargo</th>
                                        <th>Situação</th>
                                        <th>Ver Holerites</th>
                                        <th>Editar</th>
                                        <th>Trocar Senha</th>
                                        <th>Excluir</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {funcionarios.map((funcionario, index) =>
                                        <Funcionario
                                            fetchFuncionarios={fetchFuncionarios}
                                            funcionario={funcionario}
                                            key={index}
                                            editar={handleEditar}
                                            holerites={holerites}
                                            senha={handleSenha}
                                            deletar={deletar}
                                        />
                                    )}
                                </tbody>
                            </Table>
                            {loading && (
                                <Container className="text-center mt-5">
                                    <div className="d-flex justify-content-center">
                                        <div className="spinner-border" role="status" />
                                    </div>
                                    <p className="mt-3">⏳ Carregando dados, aguarde...</p>
                                </Container>

                            )}
                        </Fragment>}
                </Container>
            </Fragment>

        )
    }
}

export default FuncionariosScreen;